/**
 * JadEye 애플리케이션 마운팅 통합 유틸리티
 * 일반 사용자 앱과 관리자 앱의 완전 통합된 진입점
 * 
 * 설계 원칙:
 * - CSS는 이 유틸리티에서 한 번만 임포트 (중복 제거)
 * - 컴포넌트는 스타일과 분리된 순수 로직에만 집중
 * - 모든 공통 로직을 하나의 유틸리티로 통합
 */

import '../../css/app.css';
import { mount, type Component } from 'svelte';

interface MountConfig {
    component: Component;
    targetId?: string;
    errorMessage?: string;
}

/**
 * JadEye 앱을 안전하게 마운트하는 통합 함수
 */
export function mountJadEyeApp(config: MountConfig) {
    const {
        component,
        targetId = 'app',
        errorMessage = 'App mount target not found'
    } = config;

    const targetElement = document.getElementById(targetId);

    if (!targetElement) {
        throw new Error(errorMessage);
    }

    const app = mount(component, {
        target: targetElement,
    });

    return app;
}